import { render, staticRenderFns } from "./ConfiguracoesNotificacoes.vue?vue&type=template&id=76b8fc7e&scoped=true"
import script from "./ConfiguracoesNotificacoes.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesNotificacoes.vue?vue&type=style&index=0&id=76b8fc7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8fc7e",
  null
  
)

export default component.exports